<template>
  <div class="bottom-buttons">
    <app-btn @click="currentPage--">Previous Page</app-btn>
    <div class="pagination-info">
      <input type="text" min="1" max="166" v-model.number="currentPage" class="currentPage"> of 166
    </div>
    <app-btn @click="currentPage++">Next Page</app-btn>
  </div>
</template>

<script>
export default {
  name: "BottomButtons",
  props: {
    currentPageProp: Number
  },
  computed: {
    currentPage: {
      get() {
        return this.currentPageProp
      },
      set(val) {
        this.$emit('change', val)
      }
    }
  }
}
</script>